import { DBApplication, FormTable, SheetForm } from "../../../interfaces/CoObject";
import { Dropdown, IComboBoxOption, ResponsiveMode } from "@fluentui/react";
import React, { Dispatch, SetStateAction } from "react";
import { formatMessage } from "../../../../utils/helpers/LanguageHelper";
import useDropDownSheet from "./DropDownSheetHook";

interface DropDownSheetProps {
  isEdit?: boolean;
  sheet: SheetForm;
  form: FormTable;
  dbApplication: DBApplication;
  selectSheetComboBox: (obj: IComboBoxOption) => void;
  initAreas: (sheet: SheetForm) => void;
  type: string;
  objectSource: string;
  sheetsAreaChartMap: Map<string, string[]>;
  isFileExcelExisting?: boolean;
  isComponentInstance?: boolean;
  isLocked?: boolean;
  originalSheetArea?: SheetForm;
  setOriginalSheetArea?: Dispatch<SetStateAction<SheetForm>>;
  setIsOldSheetOrAreaSelected?: Dispatch<SetStateAction<boolean>>;
  setIsOldValueForAreaToHide?: Dispatch<SetStateAction<boolean>>;
  isOldValueForAreaToHide?: boolean;
  setHasSheetToBeSelected?: Dispatch<SetStateAction<boolean>>;
  isLoadingDataExcel?: boolean;
  setIsLoadingDataExcel?: Dispatch<SetStateAction<boolean>>;
  setIsLoadingSheetAndArea?: Dispatch<SetStateAction<boolean>>;
  setIsSheetChartAndAreaToHide?: Dispatch<SetStateAction<boolean>>;
  isSheetChartAndAreaToHide?: boolean;
  objectSourceImage?: string;
  isImageUnchecked?: boolean;
}

export const DropDownSheet = (props: DropDownSheetProps) => {
  const {
    isEdit,
    sheetsItems,
    selectSheetComboBox,
    isFileExcelExisting,
    isComponentInstance,
    isLocked,
    isOldValueForSheetToHide,
    isLoadingDataExcel,
  } = useDropDownSheet(props);

  function getSelectedKey() {
    if (props.isSheetChartAndAreaToHide && (props.isImageUnchecked || props.objectSourceImage?.includes("IMAGE"))) {
      return null;
    }
    return props.sheet?.code?.toString() ?? null;
  }

  return (
    <>
      <Dropdown
        id="sheet_dropdown"
        placeholder={isLoadingDataExcel ? formatMessage("cof.base.loadingdata") : formatMessage("cof.base.select")}
        label={formatMessage("cof.createnewobject.sheet")}
        options={isLoadingDataExcel ? [] : sheetsItems}
        onChange={(_event, option) => selectSheetComboBox(option)}
        selectedKey={getSelectedKey()}
        disabled={props.form == null || !isFileExcelExisting || isComponentInstance || isLocked}
        responsiveMode={ResponsiveMode.large}
        required
      />
      {props.objectSource === "EXCEL" && isEdit && !isLoadingDataExcel && (
        <span
          style={{ color: "red" }}
          hidden={
            !props.sheet?.code ||
            sheetsItems.length === 0 ||
            (sheetsItems.find((value) => value?.key === props?.sheet?.code) && isOldValueForSheetToHide) ||
            props.isSheetChartAndAreaToHide ||
            props.sheet?.code?.toString() !== props.sheet?.desc?.toString()
          }
        >
          {formatMessage("cof.base.oldvalue")} {props.sheet?.desc?.toString()}
        </span>
      )}
    </>
  );
};
